var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormHelper',{attrs:{"form":_vm.form,"config":_vm.formHelperConfig},on:{"change":_vm.onChange},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }